import React, { useState } from 'react';
import { Input } from "@/shared/components/ui/input";
import { Button } from "@/shared/components/ui/button";
import { Eye, EyeOff } from "lucide-react";

interface PasswordFieldProps {
  field: {
    name: string;
    label: string;
    type: string;
    placeholder?: string;
    description?: string;
    required?: boolean;
  };
  value: string;
  onChange: (value: string) => void;
}

export const PasswordField: React.FC<PasswordFieldProps> = ({ field, value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        placeholder={field.placeholder || field.description}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={field.required}
        className="pr-10"
      />
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? (
          <EyeOff className="h-4 w-4 text-muted-foreground" />
        ) : (
          <Eye className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
    </div>
  );
};
